import React from 'react';
import { create } from 'zustand';

const noopRef = React.createRef<HTMLElement>();

export type SetActivePaywallPopover = (
  popoverContent: React.JSX.Element | null,
  popoverRef: React.RefObject<HTMLElement>,
) => void;

export const usePaywallPopoversStore = create<{
  activePaywallPopoverRef: React.RefObject<HTMLElement>;
  activePaywallPopoverContent: React.JSX.Element | null;
  setActivePaywallPopover: SetActivePaywallPopover;
  closePaywallPopover: () => void;
  open: boolean;
}>((set) => ({
  activePaywallPopoverRef: noopRef,
  activePaywallPopoverContent: null,
  open: false,
  closePaywallPopover: () => set({ open: false }),
  setActivePaywallPopover: (popoverContent, popoverRef) =>
    set({
      activePaywallPopoverContent: popoverContent,
      activePaywallPopoverRef: popoverRef,
      open: true,
    }),
}));
